let isLocked = false;
let virtualScroll = 0;
let lockedSection = null;
let lockedScrollPosition = 0;
let lastScrollY = window.scrollY;
let accumulatedDelta = 0;
let unlockCooldown = false;

// Track the progress state of each section
const sectionStates = new WeakMap();

// Check if device is mobile
function isMobileDevice() {
	return window.innerWidth <= 980;
}

// Early exit if device is mobile
if (isMobileDevice()) {
	// Export empty functions so nothing breaks
	window.dayNightEnabled = false;
} else {
	window.dayNightEnabled = true;

	// Add class to body to enable CSS features
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () {
			document.documentElement.classList.add('day-night-enabled');
			document.body.classList.add('day-night-enabled');
		});
	} else {
		document.documentElement.classList.add('day-night-enabled');
		document.body.classList.add('day-night-enabled');
	}

	function normalizeHeaderHeights() {
		document
			.querySelectorAll('.day-night-section')
			.forEach(function (section) {
				const dayHeader = section.querySelector(
					'.day-night-section__content.is-day .day-night-section__content__header'
				);
				const nightHeader = section.querySelector(
					'.day-night-section__content.is-night .day-night-section__content__header'
				);
				const dayH3 = dayHeader ? dayHeader.querySelector('h3') : null;
				const nightH3 = nightHeader
					? nightHeader.querySelector('h3')
					: null;
				if (dayHeader && nightHeader) {
					const dayHeaderHeight = dayHeader.offsetHeight;
					const nightHeaderHeight = nightHeader.offsetHeight;
					const maxHeaderHeight = Math.max(
						dayHeaderHeight,
						nightHeaderHeight
					);
					dayHeader.style.minHeight = maxHeaderHeight + 'px';
					nightHeader.style.minHeight = maxHeaderHeight + 'px';
				}
				if (dayH3 && nightH3) {
					const dayH3Height = dayH3.offsetHeight;
					const nightH3Height = nightH3.offsetHeight;
					const maxH3Height = Math.max(dayH3Height, nightH3Height);
					dayH3.style.minHeight = maxH3Height + 'px';
					nightH3.style.minHeight = maxH3Height + 'px';
				}
			});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () {
			normalizeHeaderHeights();
		});
	} else {
		normalizeHeaderHeights();
	}

	function updateDayNight() {
		if (!lockedSection) {
			return;
		}
		const section = lockedSection;
		const day = section.querySelector('.day-night-section__content.is-day');
		const night = section.querySelector(
			'.day-night-section__content.is-night'
		);
		const sliderThumb = section.querySelector('.slider-thumb');
		const sliderTrack = section.querySelector('.slider-track');
		const linearProgress = Math.max(0, Math.min(1, virtualScroll));
		const easedProgress = linearProgress;

		if (day) {
			day.style.opacity = 1 - easedProgress;
		}
		if (night) {
			night.style.opacity = easedProgress;
		}

		if (easedProgress < 0.5) {
			section.classList.add('is-day');
			section.classList.remove('is-night');
		} else {
			section.classList.add('is-night');
			section.classList.remove('is-day');
		}

		if (sliderTrack) {
			const moonIcon = section.querySelector('.moon-icon');
			if (easedProgress >= 0.5) {
				sliderTrack.style.backgroundColor = '#fff';
				if (moonIcon) {
					const moonPath = moonIcon.querySelector('path');
					if (moonPath) {
						moonPath.style.fill = '#fff';
					}
				}
			} else {
				sliderTrack.style.backgroundColor = '#000';
				if (moonIcon) {
					const moonPath = moonIcon.querySelector('path');
					if (moonPath) {
						moonPath.style.fill = '#000';
					}
				}
			}
		}

		if (sliderThumb && sliderTrack) {
			const trackWidth = sliderTrack.offsetWidth;
			const thumbWidth = sliderThumb.offsetWidth;
			const maxMove = trackWidth - thumbWidth;
			sliderThumb.style.left = linearProgress * maxMove + 'px';
		}

		// Save the current progress for this section
		sectionStates.set(section, linearProgress);
	}

	function lockSection(section) {
		// Allow re-locking the same section
		if (!section) {
			return;
		}

		// If we're already locked to this section, don't re-lock
		if (isLocked && lockedSection === section) {
			return;
		}

		// If locked to a different section, unlock first
		if (isLocked && lockedSection !== section) {
			unlockSection();
		}

		// Get the saved progress for this section (default to 0 if never visited)
		let initialProgress = sectionStates.get(section);
		if (initialProgress === undefined) {
			initialProgress = 0;
		}

		// Calculate the exact scroll position of the section's top
		const rect = section.getBoundingClientRect();
		const currentScrollY = window.scrollY;
		const sectionTop = currentScrollY + rect.top;

		isLocked = true;
		lockedSection = section;
		lockedScrollPosition = sectionTop; // Use exact section position
		virtualScroll = initialProgress;
		accumulatedDelta = initialProgress * window.innerHeight * 1;

		document.body.style.position = 'fixed';
		document.body.style.top = '-' + sectionTop + 'px'; // Use exact position
		document.body.style.left = '0';
		document.body.style.right = '0';
		document.body.style.overflow = 'hidden';

		updateDayNight();
	}

	function unlockSection(scrollToPosition, forceScroll) {
		if (!isLocked) {
			return;
		}

		// Save the final progress before unlocking
		if (lockedSection) {
			sectionStates.set(lockedSection, virtualScroll);
		}

		isLocked = false;
		accumulatedDelta = 0;
		unlockCooldown = true;

		const previousScrollPosition = lockedScrollPosition;
		const previousSection = lockedSection;
		lockedSection = null;

		// Clean up any remaining styles
		document.body.style.position = '';
		document.body.style.top = '';
		document.body.style.left = '';
		document.body.style.right = '';
		document.body.style.overflow = '';

		// Handle scroll position restoration
		if (forceScroll === false) {
			// Don't force scroll - stay at locked position
			window.scrollTo(0, previousScrollPosition);
			lastScrollY = previousScrollPosition;
		} else if (scrollToPosition !== undefined) {
			// Scroll to specific position
			window.scrollTo(0, scrollToPosition);
			lastScrollY = scrollToPosition;
		} else {
			// Default: restore to where we were locked
			window.scrollTo(0, previousScrollPosition);
			lastScrollY = previousScrollPosition;
		}

		// Clear cooldown after a short delay
		setTimeout(function () {
			unlockCooldown = false;
		}, 50);
	}

	// Find which section should be locked based on scroll position
	function findSectionToLock() {
		if (isLocked) {
			return null;
		}

		let targetSection = null;
		let minDistance = Infinity;

		document
			.querySelectorAll('.day-night-section')
			.forEach(function (section) {
				const rect = section.getBoundingClientRect();

				// Lock when section top is near the viewport top
				if (rect.top >= -50 && rect.top <= 50) {
					const distance = Math.abs(rect.top);
					if (distance < minDistance) {
						minDistance = distance;
						targetSection = section;
					}
				}
			});

		return targetSection;
	}

	// Continuous monitoring with RAF
	function checkSections() {
		if (!isLocked && !unlockCooldown) {
			const scrollY = window.scrollY;
			const sectionToLock = findSectionToLock();

			if (sectionToLock) {
				const rect = sectionToLock.getBoundingClientRect();
				// Lock when close to top
				if (rect.top >= -30 && rect.top <= 30) {
					lockSection(sectionToLock);
				}
			}

			lastScrollY = scrollY;
		}

		requestAnimationFrame(checkSections);
	}

	// Start continuous monitoring
	requestAnimationFrame(checkSections);

	// Wheel event handler for desktop
	document.addEventListener(
		'wheel',
		function (e) {
			if (!isLocked) {
				return;
			}
			e.preventDefault();

			const viewportHeight = window.innerHeight;
			const totalScrollDistance = viewportHeight * 1;

			// Accumulate the actual pixel delta
			accumulatedDelta += e.deltaY;

			// Convert accumulated delta to progress (0 to 1)
			virtualScroll = Math.max(
				0,
				Math.min(1, accumulatedDelta / totalScrollDistance)
			);

			if (accumulatedDelta >= totalScrollDistance) {
				// Scrolled all the way down - unlock in place
				const section = lockedSection;
				if (section) {
					// Mark as completed
					sectionStates.set(section, 1);

					// Unlock without scrolling - just remove fixed position
					unlockSection(null, false);
				}
			} else if (accumulatedDelta <= 0) {
				// Scrolled all the way up - stay at locked position
				const section = lockedSection;
				if (section) {
					// Mark as reset
					sectionStates.set(section, 0);

					// Unlock above the section so user can continue scrolling up
					const upPosition = Math.max(0, lockedScrollPosition - 100);
					unlockSection(upPosition);
				}
			} else {
				// In the middle - update the animation
				updateDayNight();
			}
		},
		{ passive: false }
	);

	// Touch event handlers for mobile/tablet
	let lastTouchY = 0;

	document.addEventListener('touchstart', function (e) {
		if (isLocked) {
			lastTouchY = e.touches[0].clientY;
		}
	});

	document.addEventListener(
		'touchmove',
		function (e) {
			if (!isLocked) {
				return;
			}
			e.preventDefault();

			const touchY = e.touches[0].clientY;
			const touchDelta = lastTouchY - touchY;

			lastTouchY = touchY;

			const viewportHeight = window.innerHeight;
			const totalScrollDistance = viewportHeight * 1;

			// Accumulate the actual pixel delta
			accumulatedDelta += touchDelta;

			// Convert accumulated delta to progress (0 to 1)
			virtualScroll = Math.max(
				0,
				Math.min(1, accumulatedDelta / totalScrollDistance)
			);

			if (accumulatedDelta >= totalScrollDistance) {
				const section = lockedSection;
				if (section) {
					sectionStates.set(section, 1);
					unlockSection(null, false);
				}
			} else if (accumulatedDelta <= 0) {
				const section = lockedSection;
				if (section) {
					sectionStates.set(section, 0);
					const upPosition = Math.max(0, lockedScrollPosition - 100);
					unlockSection(upPosition);
				}
			} else {
				updateDayNight();
			}
		},
		{ passive: false }
	);

	// Safety mechanism: reset if something goes wrong
	window.addEventListener('resize', function () {
		if (isLocked) {
			unlockSection(lockedScrollPosition);
		}
	});

	// Prevent getting stuck on page visibility change
	document.addEventListener('visibilitychange', function () {
		if (document.hidden && isLocked) {
			unlockSection(lockedScrollPosition);
		}
	});
}

document.addEventListener('DOMContentLoaded', function () {
	const overlay = document.getElementById('alertPopup');

	if (!overlay) return;

	// Don't show popup if user has already closed it
	if (document.cookie.includes('alert_popup_closed=true')) {
		overlay.remove();
		return;
	}

	function setPopupCookie() {
		document.cookie = 'alert_popup_closed=true; path=/; max-age=2592000; SameSite=Lax';
	}

	const closeBtn = document.getElementById('alertPopupClose');

	if (closeBtn) {
		closeBtn.addEventListener('click', function () {
			setPopupCookie();
			overlay.remove();
		});
	}

	const btn = document.getElementById('alertPopupBtn');

	if (btn) {
		btn.addEventListener('click', function () {
			setPopupCookie();
		});
	}
});